import React from 'react';
import {Card} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import BreadcrumbToolbar from '../components/layouts/BreadcrumbToolbar'
import CameraTable from '../components/CameraTable';
import CameraTableMobile from '../components/CameraTableMobile';
import CameraButtonCreate from '../components/CameraButtonCreate';
import {roleStationManagement} from '../constants/defaultValues'
import {fetchCameras, postCamera, updateCamera, deleteCamera} from '../actions/camera'
import {UUID_NULL} from '../constants/defaultValues'

class StationCameras extends React.Component {
  state = {
    camera: {
      CategoryID: 2,
      Name: "",
      IP: "",
      StreamPort: 554,
      HttpPort: 80,
      ChannelNo: 0,
      UserName: "",
      Password: "",
      IsMain: false,
      Is3G: false
    }
  };

  componentWillMount() {
    this.props.dispatch(fetchCameras())
  }

  handleCreate = (values) => {
    const {
      CategoryID,
      Name,
      IP,
      StreamPort,
      HttpPort,
      ChannelNo,
      UserName,
      Password,
      IsMain,
      Is3G
    } = values
    const camera = {
      ID: UUID_NULL,
      StationID: this.props.currentStation.ID,
      CategoryID: parseInt(CategoryID, 10),
      Name: Name,
      IP: IP,
      StreamPort: StreamPort,
      HttpPort: HttpPort,
      ChannelNo: ChannelNo,
      UserName: UserName,
      Password: Password,
      IsMain: IsMain,
      Is3G: Is3G
    }
    this.props.dispatch(postCamera(camera))
  }

  handleUpdate = (values) => {
    const {
      ID,
      CategoryID,
      Name,
      IP,
      StreamPort,
      HttpPort,
      ChannelNo,
      UserName,
      Password,
      IsMain,
      Is3G
    } = values
    const camera = {
      ID: ID,
      StationID: this.props.currentStation.ID,
      CategoryID: parseInt(CategoryID, 10),
      Name: Name,
      IP: IP,
      StreamPort: StreamPort,
      HttpPort: HttpPort,
      ChannelNo: ChannelNo,
      UserName: UserName,
      Password: Password,
      IsMain: IsMain,
      Is3G: Is3G
    }
    this.props.dispatch(updateCamera(camera))
  }

  handleDelete = (camera) => {
    this.props.dispatch(deleteCamera(camera))
  }

  render() {
    const {
      currentUser,
      currentStation,
      cameras,
      categories,
      fetching,
      isMobile
    } = this.props
    const role = currentUser
      ? currentUser.role
      : 256
    const breadcrumbs = [
      {
        Name: "Quản lí trạm",
        Link: `/stations`
      }, {
        Name: currentStation.Name,
        Link: ""
      }
    ]

    return (<div>
      <div className="toolbar">
        <BreadcrumbToolbar items={breadcrumbs}/>
      </div>
      <Card className="card" title="Quản lí camera" bordered={false} extra={roleStationManagement(role)
          ? <CameraButtonCreate camera={this.state.camera
} categories={categories
} onCreate={this.handleCreate
} type="primary" text="Thêm mới" ghost={true
}/>
          : null}>
        {
          !isMobile
            ? <CameraTable role={role} cameras={cameras} categories={categories} fetching={fetching} onCreate={this.handleCreate} onUpdate={this.handleUpdate} onDelete={this.handleDelete}/>
            : <CameraTableMobile role={role} cameras={cameras} categories={categories} fetching={fetching} onCreate={this.handleCreate} onUpdate={this.handleUpdate} onDelete={this.handleDelete}/>
        }

      </Card>
    </div>);
  }
}

StationCameras.propTypes = {
  dispatch: PropTypes.func,
  currentSystem: PropTypes.object,
  currentUser: PropTypes.object,
  currentStation: PropTypes.object,
  cameras: PropTypes.array,
  categories: PropTypes.array,
  fetching: PropTypes.bool
}

const mapStateToProps = function(state) {
  return {
    currentSystem: state.system.currentSystem,
    currentUser: state.user.currentUser,
    currentStation: state.station.currentStation,
    cameras: state.camera.cameras,
    categories: state.camera.categories,
    fetching: state.camera.fetching
  }
}

export default connect(mapStateToProps)(StationCameras)



// WEBPACK FOOTER //
// ./src/pages/StationCameras.js